'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSubway = function MdSubway(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 26.5v-11.5c0-4.4-4.5-5-10-5-5 0-10 0.6-10 5v11.5c0 2.4 2 4.4 4.4 4.4l-1.9 1.8v0.7h2.8l2.5-2.5h4.7l2.5 2.5h2.5v-0.7l-1.9-1.8c2.4 0 4.4-2 4.4-4.4z m-0.3-21.8c4.4 1.7 6.9 5.4 6.9 10.1v21.8h-33.2v-21.8c0-4.7 2.5-8.4 6.9-10.1 3-1.2 6.6-1.3 9.7-1.3s6.7 0.1 9.7 1.3z m-18 10.3h16.7v8.4h-16.7v-8.4z m0.8 11.6c0-0.9 0.7-1.6 1.6-1.6s1.8 0.7 1.8 1.6-0.8 1.8-1.8 1.8-1.6-0.8-1.6-1.8z m11.6 0c0-0.9 0.8-1.6 1.8-1.6s1.6 0.7 1.6 1.6-0.7 1.8-1.6 1.8-1.8-0.8-1.8-1.8z' })
        )
    );
};

exports.default = MdSubway;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/subway.js
// module id = 2834
// module chunks = 0